import React from 'react';
import { companyInfo } from '../mockData';

const Logo = ({ className = "", textColor = "text-white" }) => {
  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      {/* Elegant Juniper Branch Icon */}
      <svg 
        width="40" 
        height="40" 
        viewBox="0 0 40 40" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        className="flex-shrink-0"
      >
        {/* Outer glow */}
        <circle 
          cx="20" 
          cy="20" 
          r="18" 
          className={textColor === "text-white" ? "fill-white" : "fill-emerald-200"}
          opacity="0.15"
        />
        
        {/* Elegant branch structure */}
        <path 
          d="M20 10 L20 30" 
          className={textColor === "text-white" ? "stroke-white" : "stroke-emerald-600"}
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        
        {/* Left leaves */}
        <path 
          d="M20 15 Q16 14 14 16" 
          className={textColor === "text-white" ? "stroke-white" : "stroke-emerald-500"}
          strokeWidth="2"
          strokeLinecap="round"
          fill="none"
        />
        <path 
          d="M20 20 Q16 19 14 21" 
          className={textColor === "text-white" ? "stroke-white" : "stroke-emerald-500"}
          strokeWidth="2"
          strokeLinecap="round"
          fill="none"
        />
        <path 
          d="M20 25 Q16 24 14 26" 
          className={textColor === "text-white" ? "stroke-white" : "stroke-emerald-500"}
          strokeWidth="2"
          strokeLinecap="round"
          fill="none"
        />
        
        {/* Right leaves */}
        <path 
          d="M20 15 Q24 14 26 16" 
          className={textColor === "text-white" ? "stroke-white" : "stroke-emerald-500"}
          strokeWidth="2"
          strokeLinecap="round"
          fill="none"
        />
        <path 
          d="M20 20 Q24 19 26 21" 
          className={textColor === "text-white" ? "stroke-white" : "stroke-emerald-500"}
          strokeWidth="2"
          strokeLinecap="round"
          fill="none"
        />
        <path 
          d="M20 25 Q24 24 26 26" 
          className={textColor === "text-white" ? "stroke-white" : "stroke-emerald-500"}
          strokeWidth="2"
          strokeLinecap="round"
          fill="none"
        />
        
        {/* Elegant sparkles */}
        <circle cx="28" cy="15" r="1.5" className={textColor === "text-white" ? "fill-white" : "fill-emerald-400"} opacity="0.8"/>
        <circle cx="12" cy="22" r="1.5" className={textColor === "text-white" ? "fill-white" : "fill-emerald-400"} opacity="0.8"/>
      </svg>
      
      {/* Elegant Typography */}
      <div className="flex flex-col leading-tight">
        <span className={`font-black text-2xl tracking-tight ${textColor}`}>
          Juniperstandard
        </span>
      </div>
    </div>
  );
};

export default Logo;